import { render, staticRenderFns } from "./TrademarkObjectionToUsStatusForm.vue?vue&type=template&id=038d8508&"
import script from "./TrademarkObjectionToUsStatusForm.vue?vue&type=script&lang=js&"
export * from "./TrademarkObjectionToUsStatusForm.vue?vue&type=script&lang=js&"
import style0 from "./TrademarkObjectionToUsStatusForm.vue?vue&type=style&index=0&id=038d8508&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports